export function safeCalculatePercent(qty: number, totalQty: number) {
    if (qty === 0 || totalQty === 0) {
        return 0;
    }
    return (qty / totalQty) * 100;
}
